import { render, staticRenderFns } from "./WarrantyClaimLineAttachments.vue?vue&type=template&id=73264af1&"
import script from "./WarrantyClaimLineAttachments.vue?vue&type=script&lang=js&"
export * from "./WarrantyClaimLineAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports